import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import { useLazyGetDashboardPayableAmountChartQuery } from "store/api/reports/reports"
import { formatAmount } from "helpers/common"

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const WealthPatnerChart = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prev) => !prev)
  const [filters, setFilters] = useState({ period: "This Year" })
  const [data, setData] = useState(null)

  const [getResults, { isFetching }] =
    useLazyGetDashboardPayableAmountChartQuery()

  const getList = async () => {
    try {
      const { data } = await getResults({ ...filters }).unwrap()
      const updatedData = {
        ...data,
        datasets: data.datasets?.map((ds) => ({
          ...ds,
          minBarLength: 20,
          data: ds.data?.map((val) => (val > 0 ? val : null)),
        })),
      }
      setData(updatedData)
    } catch (e) {
      console.error("Error fetching chart data", e)
    }
  }

  useEffect(() => {
    getList()
  }, [filters])

  // Plugin to draw circle on top of hovered bar
  const hoverCirclePlugin = {
    id: "hoverCircle",
    afterDraw(chart) {
      const activeElements = chart.getActiveElements()
      if (!activeElements.length) return

      const { ctx } = chart
      const el = activeElements[0].element
      const barTopY = el.y
      const barCenterX = el.x

      // Draw circle at top center of bar
      ctx.save()
      ctx.beginPath()
      ctx.arc(barCenterX, barTopY, 5, 0, Math.PI * 2)
      ctx.fillStyle = "#E8A838"
      ctx.fill()
      ctx.strokeStyle = "#fff"
      ctx.lineWidth = 2
      ctx.stroke()
      ctx.restore()
    },
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#545454",
        bodyColor: "#030E23",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        displayColors: false,
        cornerRadius: 8,
        padding: 10,
        titleFont: {
          family: "Poppins",
          size: 12,
          weight: "400",
        },
        bodyFont: {
          family: "Poppins",
          size: 14,
          weight: "600",
        },
        callbacks: {
          label: (context) => `₹ ${formatAmount(context.parsed.y)}`,
          title: () => "Commission",
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#3b3b3b", font: { size: 12 } },
      },
      y: {
        grid: {
          color: "#e5e5e5",
          borderDash: [2, 4],
          borderWidth: 1,
          drawTicks: false,
        },
        ticks: { display: false },
        border: { display: false },
      },
    },
  }

  return (
    <>
      <div className="chart-top-section-wrapper wealth-patner">
        <h2>Commission Payable</h2>

        <div className="dropdown-section">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret size="lg">
              {filters.period} <img src={downArrowIcon} alt="" />
            </DropdownToggle>
            <DropdownMenu style={{ minWidth: "auto" }}>
              {periods.map((item, index) => (
                <DropdownItem
                  key={`periods_${index}`}
                  onClick={() => setFilters({ period: item })}
                >
                  {item}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>

      <div style={{ width: "100%", maxWidth: "100%" }}>
        {data && (
          <Bar data={data} options={options} plugins={[hoverCirclePlugin]} />
        )}
      </div>
    </>
  )
}

export default WealthPatnerChart
